// extracted by css-extract-rspack-plugin
export default {"wrapper":"DocumentPreview_wrapper__XGPA+","hist":"DocumentPreview_hist__zgS7e"};